module.exports = __webpack_public_path__ + "img/BasedowGarten.85c539eb.jpg";